import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AdminLayoutComponent } from './ui/admin-layout/admin-layout.component';
import { LoginComponent } from './login/login.component';
import { AuthGuardService } from './core/service/auth-guard.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CustomerLayoutComponent } from './ui/customer-layout/customer-layout.component';
import { RegisterLayoutComponent } from './ui/register-layout/register-layout.component';
import { StaffGuardService } from './core/service/staff-guard.service';

const routes: Routes = [
  {
    path: '',   redirectTo: '/admin', pathMatch: 'full' },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuardService, StaffGuardService],
    children: [
      {
        path: '',
        loadChildren: './admin/admin.module#AdminModule'
      }
    ]
  },
  {
    path: 'customer',
    component: CustomerLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        loadChildren: './customer-area/customer-area.module#CustomerAreaModule'
      }
    ]
  },
  {
    path: 'register',
    component: RegisterLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: './register/register.module#RegisterModule'
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    redirectTo: 'page-not-found'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
